import { jsx as o, jsxs as t } from "react/jsx-runtime";
import { IconButton as r, Theme as n } from "@nextgen-web-framework/all";
import d from "../../VideoSection/VideoSection.js";
import '../../../assets/VideoModal.css';const i = "#ffffff", l = "#396e75", c = "#e5fdff", s = "#546223", C = "#f0fae5", V = "#a65523", z = "#fff1e8", h = "#7f3e3e", m = "#ffe2e2", g = "#62625a", u = "#f8f8e7", f = "#38539a", _ = "#707070", k = "#c8f8d1", B = "#87c9c8", v = "#5291b1", b = "rgba(82, 145, 177, 0.1019607843)", w = "#445685", y = "#181d61", G = "rgba(24, 29, 97, 0.1019607843)", O = "#5969d6", p = "#ea999d", W = "#b6577e", R = "rgba(182, 87, 126, 0.1019607843)", N = "#7e3e80", S = "#1e247f", Y = "rgba(30, 36, 127, 0.1019607843)", x = "#da7600", A = "#107f47", P = "#d91734", $ = "_html_1ueeh_38", a = {
  amwayWhite: i,
  darkBlue: l,
  lightBlue: c,
  darkGreen: s,
  lightGreen: C,
  darkOrange: V,
  lightOrange: z,
  darkRed: h,
  lightRed: m,
  darkYellow: g,
  lightYellow: u,
  darkPurple: f,
  darkGrayOnWhite: _,
  dataVizColor1: k,
  dataVizColor2: B,
  dataVizColor3: v,
  dataVizColor3Background: b,
  dataVizColor4: w,
  dataVizColor5: y,
  dataVizColor5Background: G,
  dataVizColor6: O,
  dataVizColor7: p,
  dataVizColor8: W,
  dataVizColor8Background: R,
  dataVizColor9: N,
  dataVizColor10: S,
  dataVizColor10Background: Y,
  dataVizAlertOrange: x,
  dataVizSuccessGreen: A,
  dataVizWarningRed: P,
  "no-visible": "_no-visible_1ueeh_34",
  html: $,
  "modal-container": "_modal-container_1ueeh_72",
  "modal-content": "_modal-content_1ueeh_84",
  "modal-brightCoveContainer": "_modal-brightCoveContainer_1ueeh_97",
  "video-player": "_video-player_1ueeh_103",
  "modal-close-icon": "_modal-close-icon_1ueeh_108",
  "icon-container-overwrite": "_icon-container-overwrite_1ueeh_113"
}, L = (e) => /* @__PURE__ */ o("div", { className: `${a["modal-container"]}`, "data-testid": "video-modal-testid", "data-pod-name": "commerce", children: /* @__PURE__ */ t("div", { className: `${a["modal-content"]}`, children: [
  /* @__PURE__ */ o("div", { className: `${a["modal-close-icon"]}`, children: /* @__PURE__ */ o(
    r,
    {
      iconName: "close",
      iconWithBorder: !0,
      onClick: () => {
        e.onClose();
      },
      theme: n.BLACK,
      containerClassName: a["icon-container-overwrite"]
    }
  ) }),
  /* @__PURE__ */ o(d, { ...e.videoSection, autoPlay: !0 })
] }) });
export {
  L as default
};
//# sourceMappingURL=VideoModal.js.map
